/**
 * Keeps a morph from hiding what Alpine already showed. Alpine removes
 * `x-cloak` once an element is initialised, but the server's HTML still
 * carries it, and Alpine's morph copies it back onto every visible element.
 * Until Alpine's next microtask strips it again, those sections (a whole open
 * panel) are `display: none`, and anything that measures the page in that
 * window, such as `x-trap.noscroll` opening a dialog the same render added,
 * finds the page shorter and the browser clamps the scroll position.
 */
export function keepUncloaked(el, toEl) {
    if (!el.hasAttribute("x-cloak") && toEl.hasAttribute?.("x-cloak")) {
        toEl.removeAttribute("x-cloak");
    }
}

document.addEventListener("livewire:init", () => {
    Livewire.hook("morph.updating", ({ el, toEl }) => keepUncloaked(el, toEl));
});
